import { api } from "./BackendService";

export const create = (data) => api.post("/cp/forms", data);
export const getById = (id) => api.get(`/cp/forms/${id}`);
export const remove = (id) => api.delete(`/cp/forms/${id}`);
export const edit = (id, data) => api.put(`/cp/forms/${id}`, data);
export const list = () => api.get("/cp/forms");
